import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function syncSearcherPackages(): Promise<void> {
  await post('/api/organizations/sync-searcher-packages', {});
}

/**
 * Hook to sync Python and Swift packages (shared by all orgs).
 * @returns Mutation function to trigger Python and Swift packages sync
 */
export const useSyncSearcherPackages = () => {
  return useToastedMutation({
    mutationFn: syncSearcherPackages,
    successToastMessage: 'Sync searcher packages jobs queued successfully',
    errorToastMessage: 'Failed to queue sync searcher packages jobs',
  });
};
